module.exports = __webpack_public_path__ + "img/symbol_5.22cdc455.png";